import styled from "styled-components";

export const TrendingTopicsBackground = styled.div`
  width: 517px;
  height: 482px;
  background: #ffffff;
  box-shadow: 0px 4px 4px rgba(114, 114, 114, 0.04);
  border-radius: 10px;
`;
export const TrendingTopicsTitle = styled.div`
  font-family: "Inter600";
  font-size: 24px;
  line-height: 33px;
  color: #252525;
  margin-left: 16px;
  margin-top: 16px;
  margin-bottom: 8px;
`;
export const TrendingTopicsDescription = styled.div`
  font-family: "Inter400";
  font-size: 16px;
  line-height: 22px;
  color: #252525;
  margin-left: 16px;
  margin-bottom: 35px;
`;
export const TrendingTopicsList = styled.div`
  display: flex;
  align-items: left;
  flex-direction: column;
  margin-left: 16px;
`;
export const TrendingTopicsItem = styled.div`
  font-family: "Inter400";
  font-size: 16px;
  line-height: 33px;
  color: #000000;
  display: flex;
`;
export const TrendingTopicsNumber = styled.div`
  font-family: "Inter400";
  font-size: 16px;
  line-height: 33px;
  color: #000000;
  margin-bottom: 40px;
  margin-right: 41px;
`;
